// extracted by mini-css-extract-plugin
module.exports = {"summaryItemCard":"ItemCard_summaryItemCard__DjuB0","imageWrap":"ItemCard_imageWrap__3cf7E","itemQuantity":"ItemCard_itemQuantity__2GVAt"};